export const errors = {
  'service-is-unavailable': 'Сервис временно недоступен, попробуй позже',
  'cannot-get-telegram-link': 'Не удалось получить ссылку на Telegram',
  'maybe-error': 'Возможно, есть ошибка',
  'check-email': 'Проверь правильность E-mail, чтобы мы могли связаться с тобой.',
  'check-input-correctness': 'Проверь корректность ввода!',
  'link-possibly-expired': 'Возможно, твоя ссылка устарела или отсутствует шаблон. Обратись в службу поддержки СМ',
  'interview-has-already-been-recorded': 'Интервью уже было записано ранее',
  'use-are-using-outdated-browser': `К сожалению, твой браузер не поддерживает современные технологии,
    и некоторые
    функции, такие как запись видео, могут быть недоступны.
    Для корректной работы и отображения данных воспользуйся браузерами Chrome,
    FireFox или Edge.`,
  'questionnaire-was-not-sent': 'Анкета не отправлена',
  'check-data-correctness': 'Проверь корректность введенных данных.',
  error: 'Ошибка',
  'connot-load-questionnaire-template': 'Не удалось загрузить шаблон анкеты, обратись в поддержку.',
  'somthing-went-wrong-try-leter': 'Что-то пошло не так. попробуй открыть страницу позже.',
  'no-answer-was-sent': 'Ответ не был отправлен',
  'you-can-choose-only-one-variant': 'Можно выбрать только один вариант',
  'full-name-must-contain-three-words': 'ФИО должно содержать ровно три слова с пробелами между ними!',
  'phone-must-have-format': 'Номер телефона должен иметь формат +7 (9NN) NNN-NNNN!',
  'video-interview-has-already-been-created': 'Видеоинтервью уже создано, пройди интервью.',
};
